module.exports = __webpack_public_path__ + "media/assets/img/company/logo TV5monderedi-1f7e85d2b983f84e2d2d8f2f3ba89441.png";